import React, { ReactElement, Ref } from 'react';

import { StylesConfig } from 'react-select';
import CreatableSelect from 'react-select/creatable';

import { getCustomStyles } from 'components/DesignSystem/Select/Select.utils';

type Props<T = string> = {
    options: ISelectOption<T>[];
    value?: ISelectOption<T>[];
    onChange: (data: any) => void;
    styles?: StylesConfig<any, true, any> | undefined;
    id?: string;
    placeholder?: string;
};

const SelectWithCreate = React.forwardRef(<T = string,>({ ...props }: Props<T>, ref: any) => {
    const customStyles = getCustomStyles({
        error: false,
        isFilterActive: false,
        isDisabled: false,
    });

    return <CreatableSelect ref={ref} styles={customStyles} menuPortalTarget={document.body} {...props} />;
}) as <T = string>(props: Props<T> & { ref?: Ref<any> }) => ReactElement;

export default SelectWithCreate;
